<template>
  <CardHeaderTips
    v-if="isSpecial"
    :main-text="`正在${tipText}中`"
    normal-text="，预计 2~3 分钟，无需在此等待"
    style="margin-left: -12px"
  />
  <div class="loading-card special">
    <img class="icon" :src="icon" />
    <div class="gradient-text">
      {{ tips }}
      <span v-for="(item, index) in 3" :key="index"></span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import deepThink from '@/assets/deepThink.svg'
import CardHeaderTips from '@/components/Cards/components/card-header-tips.vue'

const props = defineProps({
  icon: {
    type: String,
    default: deepThink
  },
  tips: {
    type: String,
    default: '分析中'
  },
  attributes: {
    type: Object
  }
})

// 是否跟进助手专属样式
const isSpecial = computed(() => {
  return Number(props.attributes?.assistantId) === 2
})
// 操作过程提示语
const tipText = computed(() => {
  // 操作过程提示语映射（0-通用情景，1-医疗行业情景）
  const processingStatusMap = {
    0: '入库',
    1: '分析'
  }
  const status = props.attributes?.isMedicalIndustry
  return processingStatusMap[status] || processingStatusMap[0]
})
</script>

<style lang="less" scoped>
.special {
  border-radius: 8px;
  background: #fff;
  padding: 12px;
  margin: -12px;
  width: 126px;
}
.loading-card {
  display: flex;
  font-size: 14px;
  .icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  .tips {
    color: #c8c9cc;
  }
  .gradient-text {
    display: flex;
    align-items: center;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0em;
    background: linear-gradient(90deg, #1574ff, #5952ff, #a969fe);
    -webkit-background-clip: text; /* 背景裁剪为文字形状 */
    background-clip: text; /* 标准属性 */
    color: transparent; /* 使文字本身透明，只显示渐变背景 */
    -webkit-text-fill-color: transparent; /* Safari 兼容 */
  }
  span {
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: #a969fe;
    border-radius: 50%;
    animation: bounce 1.4s infinite ease-in-out both;
    &:nth-child(1) {
      margin-left: 8px;
      animation-delay: -0.32s;
    }
    &:nth-child(2) {
      margin: 0 4px;
      animation-delay: -0.16s;
    }
  }
  @keyframes bounce {
    0%,
    80%,
    100% {
      transform: scale(0);
    }

    40% {
      transform: scale(1);
    }
  }
}
</style>
